import React from "react";
import { Helmet } from "react-helmet";
import AboutHero from "./AboutHero";
import AboutDispensary from "./AboutDispensary";
import FounderSection from "./FounderSection";
import TimelineSection from "./TimelineSection";
import ChiefBarketingOfficer from "./ChiefBarketingOfficer";
import LocationsSection from "./LocationsSection";
import { META, generateAboutRichSnippet } from "./meta";

const AboutPage: React.FC = () => {
  const richSnippet = generateAboutRichSnippet();

  return (
    <>
      <Helmet>
        <title>{META.title}</title>
        <meta name="description" content={META.meta_description} />
        <meta name="keywords" content={META.keywords} />
        <link
          rel="canonical"
          href={`https://slsdispensary.com${META.canonicalUrl}`}
        />

        {/* OpenGraph Meta Tags */}
        <meta property="og:title" content={META.title} />
        <meta property="og:description" content={META.meta_description} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://slsdispensary.com${META.canonicalUrl}`}
        />
        <meta
          property="og:image"
          content="https://slsdispensary.com/images/street-lawyer-services-dc-dispensary-entrance.jpg"
        />
        <meta property="og:site_name" content="Street Lawyer Services" />

        {/* JSON-LD for rich snippets */}
        <script type="application/ld+json">
          {JSON.stringify(richSnippet)}
        </script>
      </Helmet>

      {/* Hero Section */}
      <AboutHero />

      {/* About the Dispensary */}
      <AboutDispensary />

      {/* Founder Section */}
      <FounderSection />

      {/* Timeline Section */}
      <TimelineSection />

      {/* ChiefBarketingOfficer Section */}
      <ChiefBarketingOfficer />

      {/* Locations Section */}
      <LocationsSection />

      {/* Call to Action Section */}
      <section className="py-16 bg-law-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Visit Street Lawyer Services Today
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Experience premium cannabis products at our Washington DC
            dispensary. Our knowledgeable team is ready to assist you in finding
            the perfect products for your needs.
          </p>
          <div className="flex justify-center">
            <a href="/locations" className="btn-primary">
              View Location Details
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutPage;
